import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Col, Container, Input, Row, Table } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getRoles } from "../../store/actions";
//redux
import { useDispatch, useSelector } from "react-redux";
import {
  addPermissionList,
  getPermissionFields,
  getPermissionList,
  updatePermissionList,
} from "http/fundLync/rolesPermissions";
import Loader from "react-spinner-loader";
import ToastDialog from "components/Common/ToastDialog";
import CommonDialog from "components/Common/CommonDialog";
import { decryptedValue, uId } from "common/utility";
import { getRole } from "../../http/fundLync/role.helper";

const CustomRolesPermission = (props) => {
  //meta title
  document.title = "Role Permission | FundLync";
  const dispatch = useDispatch();
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [id, setId] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const roleData = useSelector((state) => ({
    roles: state.addRole,
    rolePermissions: state.rolePermission.data,
  }));
  // State to track the checked state of category checkboxes
  const [categoryCheckboxes, setCategoryCheckboxes] = useState({});
  const [childCheckboxes, setChildCheckboxes] = useState({});
  const [subChildCheckboxes, setSubChildCheckboxes] = useState(null);
  const [permissionFields, setPermissionFields] = useState(null);
  const [update, setUpdate] = useState(false);
  const user = decryptedValue(localStorage.getItem("user"));
  const navigate = useNavigate();


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      roleName: selectedRoleName || "",
      role: selectedRole || "",
    },
    validationSchema: Yup.object({
      roleName: Yup.number().required("Please select Entity"),
    }),
  });

  useEffect(() => {
    dispatch(getRoles());
  }, []);

  useEffect(() => {
    getAllRoles()
    getPermissionFields()
      .then(({ data }) => {
        const moduleNames = [
          ...new Set(data.rows.map((item) => item.module.moduleName)),
        ];
        const filteredData = moduleNames.map((moduleName) => ({
          moduleName: moduleName,
          permissions: data.rows.filter(
            (item) => item.module.moduleName === moduleName
          ),
        }));
        setPermissionFields(filteredData.map((obj) => Object.assign(obj, { uId: uId() })));
      })
      .catch((err) => console.error(err));
  }, []);

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    const values = e.target.value.split(",");
    const roleName = values[1];
    const role = values[0];

    setSelectedRoleName(roleName);
    setSelectedRole(role);

    validation.setFieldValue("roleName", roleName);
    validation.setFieldValue("role", role);
    setLoader(true);
    fetchPermissionList(role);
  };

  const fetchPermissionList = (role) => {
    getPermissionList({ roleName: role })
      .then(({ data }) => {
        setShowTable(true);
        setLoader(false);

        const transformedOutput = {};

        permissionFields.forEach((module) => {
          const outputModule = {
            module_name: module.moduleName,
          };

          module.permissions.forEach((permission) => {
            const {
              permission_name,
              isCreate,
              isEdit,
              isView,
              isDelete,
              isList,
              isApprove,
              isReject,
              isFullAccess,
            } = permission;
            const permissionValues = [
              isCreate === null ? null : 0,
              isEdit === null ? null : 0,
              isView === null ? null : 0,
              isDelete === null ? null : 0,
              isList === null ? null : 0,
              isApprove === null ? null : 0,
              isReject === null ? null : 0,
              isFullAccess === null ? null : 0,
            ];

            outputModule[permission_name] = permissionValues;
          });

          transformedOutput[module.moduleName] = outputModule;
        });

        const desiredOutput = {
          permissionList: Object.values(transformedOutput),
        };

        if (data?.length === 0) {
          setRolePermissionList(desiredOutput);
          setUpdate(false);
        } else {
          setRolePermissionList((prevPermissionList) => {
            const updatedPermissionList = desiredOutput.permissionList.map(
              (module) => {
                // Check if there is corresponding data for the module in the received data
                const moduleData = data[0]?.permission_list.find(
                  (dataModule) => dataModule.module_name === module.module_name
                );

                if (moduleData) {
                  // Merge the module data with the existing module
                  return {
                    ...module,
                    ...moduleData,
                  };
                }

                // If there's no corresponding data, return the existing module
                return module;
              }
            );
            return {
              permissionList: updatedPermissionList,
            };
          });
          setId(data[0].id);
          setUpdate(true);
        }
      })
      .catch((error) => {
        setRolePermissionList(null);
        setLoader(false);
      });
  }

  useEffect(() => {
    // Initialize category checkboxes state based on rolePermissionList
    if (rolePermissionList?.permissionList?.length > 0) {
      const initialCategoryCheckboxes = {};
      const initialSubCategoryCheckboxes = {};
      rolePermissionList.permissionList?.forEach((elem) => {
        initialCategoryCheckboxes[elem.module_name] = areAllChildValuesOne(
          elem.module_name
        );
        for (const key in elem) {
          if (key !== "module_name") {
            initialSubCategoryCheckboxes[key] = areAllActionsChecked(elem[key]);
          }
        }
      });

      let allSubChildCheckboxes = {
        view: false,
        edit: false,
        delete: false,
        create: false,
        approve: false,
        list: false,
        fullAccess: false,
        reject: false,
      };
      const categories = Object.keys(initialCategoryCheckboxes);
      // Create an array of objects for each category and its associated permissions
      const combinedObjects = categories.map((category) => {
        let data = rolePermissionList.permissionList.find(
          (i) => i.module_name === category
        );
        let view = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[2] === 1 || value[2] === null;
          }
          return true;
        });
        let edit = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[1] === 1 || value[1] === null;
          }
          return true;
        });
        let isDelete = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[3] === 1 || value[3] === null;
          }
          return true;
        });
        let create = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[0] === 1 || value[0] === null;
          }
          return true;
        });
        let approve = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[5] === 1 || value[5] === null;
          }
          return true;
        });
        let fullAccess = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[7] === 1 || value[7] === null;
          }
          return true;
        });
        let list = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[4] === 1 || value[7] === null;
          }
          return true;
        });
        let reject = Object.entries(data).every(([key, value]) => {
          if (key !== "module_name") {
            return value[6] === 1 || value[6] === null;
          }
          return true;
        });
        allSubChildCheckboxes = {
          view: view,
          edit: edit,
          delete: isDelete,
          create: create,
          approve: approve,
          list: list,
          fullAccess: fullAccess,
          reject: reject,
        };
        return {
          category,
          ...allSubChildCheckboxes,
        };
      });
      setSubChildCheckboxes(combinedObjects);
      setCategoryCheckboxes(initialCategoryCheckboxes);
      setChildCheckboxes(initialSubCategoryCheckboxes);
    }
  }, [rolePermissionList]);

  const getChildKeys = (element) => {
    return Object.keys(element).filter((key) => key !== "module_name");
  };

  const handleCategorySelection = (category, val) => {
    let categoryObJ = rolePermissionList?.permissionList.find(
      (i) => i.module_name === category
    );
    if (!categoryCheckboxes[category]) {
      const updatedObject = { ...categoryObJ }; // Create a copy of the object

      for (const key in updatedObject) {
        if (key !== "module_name") {
          // Check if the value is not null
          updatedObject[key] = categoryObJ[key].map((value) =>
            value === null ? null : 1
          );
        }
      }

      setRolePermissionList((prevState) => {
        const updatedModule = updatedObject.module_name;

        // Check if the module_name already exists in the permissionList
        const moduleExists = prevState.permissionList.some(
          (item) => item.module_name === updatedModule
        );

        if (!moduleExists) {
          // If the module_name doesn't exist, add updatedObject to the list
          return {
            permissionList: [...prevState.permissionList, updatedObject],
          };
        }

        // If the module_name already exists, update the existing object
        const updatedPermissionList = prevState.permissionList.map((item) => {
          if (item.module_name === updatedModule) {
            // Update the existing object with updatedObject
            return updatedObject;
          } else {
            return item;
          }
        });

        return { permissionList: updatedPermissionList };
      });
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category]: true,
      }));
      setChildCheckboxes((prevChildCheckboxes) => {
        const updatedChildCheckboxes = { ...prevChildCheckboxes };
        for (const key in categoryObJ) {
          if (key !== "module_name") {
            updatedChildCheckboxes[key] = true;
          }
        }
        return updatedChildCheckboxes;
      });
      subChildCheckboxes?.forEach((i) => {
        if (i.category === category) {
          i.view = true;
          i.edit = true;
          i.delete = true;
          i.create = true;
          i.approve = true;
          i.list = true;
          i.fullAccess = true;
          i.reject = true;
        }
      });
      setSubChildCheckboxes([...subChildCheckboxes]);
    } else {
      const updatedObject = { ...categoryObJ }; // Create a copy of the object

      for (const key in updatedObject) {
        if (key !== "module_name") {
          // Check if the value is not null
          updatedObject[key] = categoryObJ[key].map((value) =>
            value === null ? null : 0
          );
        }
      }

      setRolePermissionList((prevState) => {
        const updatedModule = updatedObject.module_name;

        // Check if the module_name already exists in the permissionList
        const moduleExists = prevState.permissionList.some(
          (item) => item.module_name === updatedModule
        );

        if (!moduleExists) {
          // If the module_name doesn't exist, add updatedObject to the list
          return {
            permissionList: [...prevState.permissionList, updatedObject],
          };
        }

        // If the module_name already exists, update the existing object
        const updatedPermissionList = prevState.permissionList.map((item) => {
          if (item.module_name === updatedModule) {
            // Update the existing object with updatedObject
            return updatedObject;
          } else {
            return item;
          }
        });

        return { permissionList: updatedPermissionList };
      });
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category]: false,
      }));
      setChildCheckboxes((prevChildCheckboxes) => {
        const updatedChildCheckboxes = { ...prevChildCheckboxes };
        for (const key in categoryObJ) {
          if (key !== "module_name") {
            updatedChildCheckboxes[key] = false;
          }
        }
        return updatedChildCheckboxes;
      });
      subChildCheckboxes.forEach((i) => {
        if (i.category === category) {
          i.view = false;
          i.edit = false;
          i.delete = false;
          i.create = false;
          i.approve = false;
          i.list = false;
          i.fullAccess = false;
          i.reject = false;
        }
      });
      setSubChildCheckboxes([...subChildCheckboxes]);
    }
  };

  function areAllChildValuesOne(category) {
    const categoryPermission = rolePermissionList.permissionList.find(
      (permission) => permission.module_name === category
    );

    if (categoryPermission) {
      // Extract all values of the object, omitting the 'module_name' key
      const values = Object.keys(categoryPermission)
        .filter((key) => key !== "module_name")
        .map((key) => categoryPermission[key]);

      // Check if all values are equal to 1
      return values.every((innerArray) => {
        return innerArray.every((value) => value === 1 || value === null);
      });
    }

    return false; // Return false if categoryPermission is not found
  }

  const handleActionCheckboxChange = (
    event,
    category,
    key,
    actionIndex,
    name
  ) => {
    const { checked } = event.target;
    category[key][actionIndex] = checked ? 0 : 1;
    // Update the state with the modified permission list
    setRolePermissionList({ ...rolePermissionList });

    // If all child actions are checked, update the category checkbox
    if (!checked) {
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category.module_name]: areAllChildActionsChecked(category),
      }));
      setChildCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [key]: areAllActionsChecked(category[key]),
      }));
      let obj = subChildCheckboxes.find(
        (i) => i.category === category.module_name
      );

      const allKeysHaveOne = Object.entries(category).every(([key, value]) => {
        if (key !== "module_name") {
          return value[actionIndex] === 1;
        }
        return true; // Skip 'module_name'
      });

      Object.keys(obj).forEach((key) => {
        if (obj[key] !== category.moduleName && allKeysHaveOne) {
          obj[name] = true;
        }
      });
      setSubChildCheckboxes([...subChildCheckboxes]);
    }
    // If any child action is unchecked, update the category checkbox
    if (checked) {
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category.module_name]: false,
      }));
      setChildCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [key]: false,
      }));
      let obj = subChildCheckboxes.find(
        (i) => i.category === category.module_name
      );
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== category.moduleName) {
          obj[name] = false;
        }
      });
      setSubChildCheckboxes([...subChildCheckboxes]);
      //   }
    }
  };

  const areAllChildActionsChecked = (category) => {
    // Check if all child actions are checked (values are 1)
    return getChildKeys(category).every((key) => {
      if (childCheckboxes[key]) {
        if (category[key].every((action) => action === 1 || action === null)) {
          return true;
        }
      } else {
        return category[key].every((action) => action === 1 || action === null);
      }
    });
  };

  const areAllActionsChecked = (category) => {
    // Check if all child actions are checked (values are 1)

    return category.every((value) => value === 1 || value === null);
  };
  const handleChildCategorySelection = (category, event, selectedKey) => {

    const categoryPermission = rolePermissionList.permissionList.find(
      (permission) => permission.module_name === category.moduleName
    );

    if (categoryPermission) {
      // Iterate through the permission object and update child permissions
      for (const key in categoryPermission) {
        if (key !== "module_name" && key === selectedKey) {
          categoryPermission[key] = !childCheckboxes[selectedKey]
            ? categoryPermission[key].map((value) =>
              value === null ? null : 1
            )
            : categoryPermission[key].map((value) =>
              value === null ? null : 0
            );
        }
      }
      setRolePermissionList({ ...rolePermissionList });
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category.moduleName]: areAllChildActionsChecked(categoryPermission),
      }));
      setChildCheckboxes((prevChildCheckboxes) => {
        const updatedChildCheckboxes = { ...prevChildCheckboxes };
        for (const key in categoryPermission) {
          if (key !== "module_name" && key === selectedKey) {
            updatedChildCheckboxes[key] = !childCheckboxes[key];
          }
        }
        return updatedChildCheckboxes;
      });
      let obj = subChildCheckboxes.find(
        (i) => i.category === category.moduleName
      );
      let data = rolePermissionList.permissionList.find(
        (i) => i.module_name === category.moduleName
      );
      let view = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[2] === 1 || value[2] === null;
        }
        return true;
      });
      let edit = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[1] === 1 || value[1] === null;
        }
        return true;
      });
      let isDelete = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[3] === 1 || value[3] === null;
        }
        return true;
      });
      let create = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[0] === 1 || value[0] === null;
        }
        return true;
      });
      let approve = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[5] === 1 || value[5] === null;
        }
        return true;
      });
      let fullAccess = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[7] === 1 || value[7] === null;
        }
        return true;
      });
      let list = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[4] === 1 || value[4] === null;
        }
        return true;
      });
      let reject = Object.entries(data).every(([key, value]) => {
        if (key !== "module_name") {
          return value[6] === 1 || value[6] === null;
        }
        return true;
      });
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== category.moduleName) {
          if (key === "view") {
            obj[key] = view;
          } else if (key === "edit") {
            obj[key] = edit;
          } else if (key === "delete") {
            obj[key] = isDelete;
          } else if (key === "create") {
            obj[key] = create;
          } else if (key === "approve") {
            obj[key] = approve;
          } else if (key === "fullAccess") {
            obj[key] = fullAccess;
          } else if (key === "list") {
            obj[key] = list;
          } else if (key === "reject") {
            obj[key] = reject;
          }
        }
      });
      setSubChildCheckboxes([...subChildCheckboxes]);
    }
  };

  const handleAll = (selectedKey, category, activeIndex) => {
    try {
      const categoryPermission = rolePermissionList.permissionList.find(
        (permission) => permission.module_name === category
      );

      const track = subChildCheckboxes.find((i) => i.category === category);

      for (const key in categoryPermission) {
        if (categoryPermission.hasOwnProperty(key) && key !== "module_name") {
          if (!track[selectedKey]) {
            categoryPermission[key][activeIndex] = 1;
          } else {
            categoryPermission[key][activeIndex] = 0;
          }
        }
      }
      subChildCheckboxes.find((i) => i.category === category)[selectedKey] =
        !track[selectedKey];
      setSubChildCheckboxes([...subChildCheckboxes]);
      setCategoryCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [category]: areAllChildActionsChecked(categoryPermission),
      }));
      let subFields = permissionFields
        ?.find((e) => e.moduleName === category)
        .permissions.map((i) => i.permission_name);
      setChildCheckboxes((prevChildCheckboxes) => {
        const updatedChildCheckboxes = { ...prevChildCheckboxes };
        for (const fields in subFields) {
          if (
            track[selectedKey] &&
            areAllActionsChecked(categoryPermission[subFields[fields]])
          ) {
            updatedChildCheckboxes[subFields[fields]] = true;
          } else {
            updatedChildCheckboxes[subFields[fields]] = false;
          }
        }
        return updatedChildCheckboxes;
      });
      setRolePermissionList({ ...rolePermissionList });
    } catch (error) {
      console.error(error);
    }
  };

  const submitRolePermission = () => {
    setShowCommonDialog({ isShow: true, message: 'Are you sure want to update Role Permissions?' })
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      handleSubmit()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  const handleSubmit = () => {
    setLoader(true);
    if (!update) {
      addPermissionList({
        roleId: selectedRoleName,
        permissionList: rolePermissionList.permissionList,
      })
        .then((res) => {
          fetchPermissionList(selectedRole);
          setLoader(false);
          setToastInfo({
            message: " updated successfully",
            showToast: true,
            role: "success",
          });
          setUpdate(true);
        })
        .catch((err) => {
          setLoader(false);
          setToastInfo({
            message: " add failed",
            showToast: true,
            role: "error",
          });
        });
    } else {
      updatePermissionList({
        permissionList: rolePermissionList.permissionList,
        roleId: selectedRoleName,
        id: id,
      })
        .then((res) => {
          fetchPermissionList(selectedRole);
          setLoader(false);
          setToastInfo({
            message: " updated successfully",
            showToast: true,
            role: "success",
          });
        })
        .catch((err) => {
          setLoader(false);
          setToastInfo({
            message: " add failed",
            showToast: true,
            role: "error",
          });
        });
    }
  };

  const handleNavigateRoles = () => {
    navigate(`/${user.roleName}/roles`);
  };

  const handleNavigatePermission = () => {
    navigate(`/${user.roleName}/permission`);
  };

  const getAllRoles = () => {
    getRole({ page:1, limit: 20})
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data.data);
        } 
      }).catch(error => { })

  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Col style={{
            width: '100%'
          }}
            className="d-flex justify-content-between align-items-center mb-3">
            <Breadcrumbs title="ROLE PERMISSIONS" />
            <div>
              <button
                onClick={handleNavigatePermission}
                className="btn btn-outline-success ms-4"
                type="button"
              >
                Show Permissions
              </button>

              <button
                onClick={handleNavigateRoles}
                className="btn btn-outline-success ms-4"
                type="button"
              >
                Show Roles
              </button>
            </div>
          </Col>
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <div
                    style={{ display: "flex"}}
                  >
                    <Col
                      md="2"
                      className="d-flex align-items-center mb-3"
                      style={{ width: "20%" }}
                    >
                      <label className="mt-1 me-3 font-size-14">Role:</label>
                      <Input
                        name="roleType"
                        type="select"
                        onChange={(e) => {
                          const values = e.target.value.split(",");
                          validation.values.roleName = values[1];
                          validation.values.role = values[0];
                          handleSelectChange(e);
                        }}
                        value={selectedValue || ""}
                      >
                        <option value="" disabled>
                          Select role type
                        </option>
                        {roleList.map((depo) => (
                          <option
                            key={depo.id}
                            value={[depo.roleName, depo.id]}
                          >
                            {(depo.displayName)}
                          </option>
                        ))}
                      </Input>
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "1rem",
                        width: 'fit-content'
                      }}
                      md="2"
                      className="d-flex align-items-center mb-3"
                    >
                      {showTable && (<button
                        onClick={submitRolePermission}
                        className="btn btn-success save-customer ms-4"
                      >
                        Save
                      </button>)}
                    </Col>
                  </div>

                  <Row className="vertical-scroll">
                    <Col xs="12">
                      {showTable && (
                        <>
                        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                        <Table
                          style={{
                            backgroundColor: "white !important",
                          }}
                        >
                          <thead>
                            <tr style={{ backgroundColor: "white" }}>
                              <th style={{ backgroundColor: "white" }}>Id</th>
                              <th style={{ backgroundColor: "white" }}>
                                Permissions
                              </th>
                              <th
                                style={{
                                  backgroundColor: "white",
                                  paddingLeft: "1.6rem",
                                }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {permissionFields?.length == 0 ? (
                              <tr style={{ backgroundColor: "white" }}>
                                <td
                                  style={{ backgroundColor: "white" }}
                                  colSpan={7}
                                  className="text-center"
                                >
                                  No data found
                                </td>
                              </tr>
                            ) : (
                              permissionFields?.map((elem, index) => {
                                let trackSub = subChildCheckboxes?.find(
                                  (i) => i.category === elem.moduleName
                                );

                                return (
                                  <tr
                                    style={{ backgroundColor: "white" }}
                                    key={elem.uid}
                                  >
                                    <td style={{ backgroundColor: "white" }}>
                                      {index + 1}
                                    </td>
                                    <td style={{ backgroundColor: "white" }}>
                                      {/* Nested table for child structure */}
                                      <div
                                        style={{ display: "flex", gap: "16px" }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={
                                            categoryCheckboxes[elem.moduleName]
                                          }
                                          onClick={(e) =>
                                            handleCategorySelection(
                                              elem.moduleName,
                                              e
                                            )
                                          }
                                        />
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                          }}
                                        >
                                          {" "}
                                          {elem?.permissions[0]?.module?.moduleDisplayName}
                                        </div>
                                      </div>
                                      <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                      <table
                                        style={{
                                          marginLeft: "29px",
                                          marginTop: "5px",
                                        }}
                                      >
                                        <tbody
                                          style={{ backgroundColor: "white" }}
                                        >
                                          <tr
                                            style={{ backgroundColor: "white" }}
                                          >
                                            {elem.permissions.map((key) => (
                                              <div
                                                key={key.id}
                                                style={{
                                                  display: "flex",
                                                  gap: "15px",
                                                  marginTop: "19px",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    childCheckboxes[
                                                    key.permission_name
                                                    ]
                                                  }
                                                  onClick={(e) =>
                                                    handleChildCategorySelection(
                                                      elem,
                                                      e,
                                                      key.permission_name
                                                    )
                                                  }
                                                />
                                                {/* Render child data based on key */}
                                                <div
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {
                                                    key.permission_display_name
                                                  }
                                                </div>
                                              </div>
                                            ))}
                                            {/* Add more child data cells here */}
                                          </tr>
                                          {/* Add more rows for child data as needed */}
                                        </tbody>
                                      </table>
                                      </div>
                                    </td>
                                    <td style={{ backgroundColor: "white" }}>
                                      <table
                                        style={{
                                          marginLeft: "16px",
                                          backgroundColor: "white",
                                          // marginTop: "12px",
                                        }}
                                      >
                                        <tbody
                                          style={{ backgroundColor: "white" }}
                                        >
                                          <tr
                                            style={{ backgroundColor: "white" }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "10px",
                                              }}
                                            >
                                              {/* Render child data based on key */}
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isList === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isList === null
                                                    )
                                                      ? false
                                                      : trackSub?.list
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "list",
                                                      elem.moduleName,
                                                      4
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isList === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  List
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isCreate === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isCreate === null
                                                    )
                                                      ? false
                                                      : trackSub?.create
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "create",
                                                      elem.moduleName,
                                                      0
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isCreate === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  Add
                                                </label>
                                              </div>

                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isEdit === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isEdit === null
                                                    )
                                                      ? false
                                                      : trackSub?.edit
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "edit",
                                                      elem.moduleName,
                                                      1
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isEdit === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  Edit
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isDelete === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isDelete === null
                                                    )
                                                      ? false
                                                      : trackSub?.delete
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "delete",
                                                      elem.moduleName,
                                                      3
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isDelete === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  Delete
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isView === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isView === null
                                                    )
                                                      ? false
                                                      : trackSub?.view
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "view",
                                                      elem.moduleName,
                                                      2
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isView === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  View
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) =>
                                                        i.isApprove === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) =>
                                                        i.isApprove === null
                                                    )
                                                      ? false
                                                      : trackSub?.approve
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "approve",
                                                      elem.moduleName,
                                                      5
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isApprove === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  Approve
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) => i.isReject === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) => i.isReject === null
                                                    )
                                                      ? false
                                                      : trackSub?.reject
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "reject",
                                                      elem.moduleName,
                                                      6
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) => i.isReject === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  Reject
                                                </label>
                                              </div>
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    elem.permissions.every(
                                                      (i) =>
                                                        i.isFullAccess === null
                                                    )
                                                      ? ""
                                                      : "form-check-input"
                                                  }
                                                  checked={
                                                    elem.permissions.every(
                                                      (i) =>
                                                        i.isFullAccess === null
                                                    )
                                                      ? false
                                                      : trackSub?.fullAccess
                                                  }
                                                  onClick={(e) => {
                                                    handleAll(
                                                      "fullAccess",
                                                      elem.moduleName,
                                                      7
                                                    );
                                                  }}
                                                  disabled={elem.permissions.every(
                                                    (i) =>
                                                      i.isFullAccess === null
                                                  )}
                                                />
                                                <label
                                                  htmlFor="key4"
                                                  className="me-4 ms-2"
                                                  style={{
                                                    fontWeight: "650",
                                                    fontSize: "12.7px",
                                                  }}
                                                >
                                                  All Records
                                                </label>
                                              </div>
                                            </div>

                                            {elem?.permissions.map(
                                              (key, index) => {
                                                let permissionTrack =
                                                  rolePermissionList.permissionList.find(
                                                    (i) =>
                                                      i.module_name ===
                                                      elem.moduleName
                                                  );
                                                return (
                                                  <div
                                                    key={key?.id}
                                                    style={{
                                                      display: "flex",
                                                      gap: "10.3px",
                                                      marginTop: "17.9px",
                                                    }}
                                                  >
                                                    {/* Render child data based on key */}
                                                    {key?.isList !== null ? (
                                                      <div>
                                                        <input
                                                        
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][4] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              4,
                                                              "list"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          List
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          List
                                                        </label>
                                                      </div>
                                                    )}
                                                    {key?.isCreate !==
                                                      null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][0] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              0,
                                                              "create"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          Add
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          Add
                                                        </label>
                                                      </div>
                                                    )}

                                                    {key?.isEdit !== null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][1] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              1,
                                                              "edit"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          Edit
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          Edit
                                                        </label>
                                                      </div>
                                                    )}
                                                    {key?.isDelete !==
                                                      null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][3] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              3,
                                                              "delete"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          Delete
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          Delete
                                                        </label>
                                                      </div>
                                                    )}
                                                    {key?.isView !== null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][2] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              2,
                                                              "view"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          View
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          View
                                                        </label>
                                                      </div>
                                                    )}
                                                    {key.isApprove !==
                                                      null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][5] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              5,
                                                              "approve"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          Approve
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          Approve
                                                        </label>
                                                      </div>
                                                    )}

                                                    {key?.isReject !==
                                                      null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][6] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              6,
                                                              "reject"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          Reject
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "#9BA4B5",
                                                          }}
                                                        >
                                                          Reject
                                                        </label>
                                                      </div>
                                                    )}
                                                    {key?.isFullAccess !==
                                                      null ? (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input"
                                                          checked={
                                                            permissionTrack[
                                                            key
                                                              .permission_name
                                                            ][7] === 1
                                                          }
                                                          onClick={(e) =>
                                                            handleActionCheckboxChange(
                                                              e,
                                                              permissionTrack,
                                                              key.permission_name,
                                                              7,
                                                              "fullAccess"
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                        >
                                                          All Records
                                                        </label>
                                                      </div>
                                                    ) : (
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          disabled={true}
                                                        />
                                                        <label
                                                          htmlFor="key4"
                                                          className="me-4 ms-2"
                                                          style={{
                                                            color: "grey",
                                                          }}
                                                        >
                                                          All Records
                                                        </label>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}
                                            {/* Add more child data cells here */}
                                          </tr>
                                          {/* Add more rows for child data as needed */}
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </Table>
                        </div></>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
    </React.Fragment>
  );
};

export default CustomRolesPermission;
